import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import SidebarLink from './SidebarLink';
import SidebarCategory from './SidebarCategory';
import global from '../../../global';

const UserImg = `${process.env.PUBLIC_URL}/images/users/default_user.png`;

class SidebarContent extends Component {
  static propTypes = {
    // changeToDark: PropTypes.func.isRequired,
    // changeToLight: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.state = {};
    this.userdata = JSON.parse(localStorage.getItem('userData'));
  }

  hideSidebar = () => {
    const { onClick } = this.props;
    onClick();
  };

  render() {
    // const { changeToLight, changeToDark } = this.props;
    if (this.userdata === null) {
      return (<Redirect to="/login" />);
    }
    const user = this.userdata;
    const { userType } = global;
    const inventoryType = userType[user.type].toLowerCase();
    const type = parseInt(user.type, 10);

    const urls = window.location.pathname.split('/').filter(Boolean);
    if (urls[0] !== 'inventory') {
      localStorage.removeItem('warehouseInventoryDate');
      localStorage.removeItem('commissaryInventoryDate');
      localStorage.removeItem('storeInventoryDate');
    } else if (urls[0] !== 'report') {
      localStorage.removeItem('salesReportDate');
    }

    return (
      <div className="sidebar__content">
        <div className="sidebar_userinfo">
          <div className="userinfo-img_box">
            <img className="userinfo-img" src={UserImg} alt="avatar" />
          </div>
          <div className="userinfo-text">
            <h3 className="userinfo-name">{user.name} <span>{userType[user.type]}</span></h3>
          </div>
        </div>
        <ul className="sidebar__block">
          {
            type === 1 || type === 5 ? (
              <div>
                <SidebarLink title="Dashboard" faIcon="home" route="/dashboard" onClick={this.hideSidebar} />
                <SidebarLink title="Location" faIcon="map-marked" route="/locations" onClick={this.hideSidebar} />
                <SidebarLink title="Users" faIcon="users" route="/users" onClick={this.hideSidebar} />
                <SidebarLink title="Products" faIcon="shopping-cart" route="/products" onClick={this.hideSidebar} />
                <SidebarLink title="Suppliers" faIcon="parachute-box" route="/suppliers" onClick={this.hideSidebar} />
                <SidebarLink title="Customers" faIcon="users" route="/customers" onClick={this.hideSidebar} />
                <SidebarLink title="Inventory" faIcon="warehouse" route="/inventory" onClick={this.hideSidebar} />
                {/* <SidebarLink title="Report" faIcon="chart-line" route="/report" onClick={this.hideSidebar} /> */}
                <SidebarLink title="Stock Returned" faIcon="undo" route="/return" onClick={this.hideSidebar} />
                <SidebarLink title="Transactions" faIcon="shopping-cart" route="/transactions" onClick={this.hideSidebar} />
                <SidebarCategory title="Report" icon="file-empty">
                  <SidebarLink title="Sales Report" route="/report/sales" onClick={this.hideSidebar} />
                  <SidebarLink title="Incident Report" route="/report/incident" onClick={this.hideSidebar} />
                  <SidebarLink title="Archived Transactions" route="/transactions/archived" onClick={this.hideSidebar} />
                </SidebarCategory>
              </div>
            ) : type === 6 ? (
              <div>
                <SidebarLink title="Dashboard" faIcon="home" route="/dashboard" onClick={this.hideSidebar} />
                <SidebarLink title="Location" faIcon="map-marked" route="/locations" onClick={this.hideSidebar} />
                <SidebarLink title="Products" faIcon="shopping-cart" route="/products" onClick={this.hideSidebar} />
                <SidebarLink title="Suppliers" faIcon="parachute-box" route="/suppliers" onClick={this.hideSidebar} />
                <SidebarLink title="Inventory" faIcon="warehouse" route="/inventory" onClick={this.hideSidebar} />
              </div>
            ) : type === 4 ? (
              <div>
                <SidebarLink title="Dashboard" faIcon="home" route="/dashboard" onClick={this.hideSidebar} />
                <SidebarLink title="Transactions" faIcon="shopping-cart" route="/transactions" onClick={this.hideSidebar} />
                <SidebarLink title="Remaining Stocks" faIcon="warehouse" route="/stocks" onClick={this.hideSidebar} />
                <SidebarLink title="Customers" faIcon="users" route="/customers" onClick={this.hideSidebar} />
                <SidebarLink title="Stock Return" faIcon="undo" route="/return" onClick={this.hideSidebar} />
                <SidebarLink title="Sales Report" icon="file-empty" route="/report/sales" onClick={this.hideSidebar} />
              </div>
            ) : (
              <div>
                <SidebarLink title="Inventory" faIcon="warehouse" route={`/inventory/${inventoryType}/dashboard/${user.location_id}`} onClick={this.hideSidebar} />
                <SidebarLink title="Transactions" faIcon="shopping-cart" route="/transactions" onClick={this.hideSidebar} />
                <SidebarLink title="Customers" faIcon="users" route="/customers" onClick={this.hideSidebar} />
                <SidebarLink title="Stock Returned" faIcon="undo" route="/return" onClick={this.hideSidebar} />
                <SidebarLink title="Sales Report" icon="file-empty" route="/report/sales" onClick={this.hideSidebar} />
              </div>
            )
          }
          {/* <SidebarLink title="Location" faIcon="map-marked" route="/locations" onClick={this.hideSidebar} />
          <SidebarLink title="Users" faIcon="users" route="/users" onClick={this.hideSidebar} />
          <SidebarLink title="Products" faIcon="shopping-cart" route="/products" onClick={this.hideSidebar} />
          <SidebarLink title="Suppliers" faIcon="parachute-box" route="/suppliers" onClick={this.hideSidebar} />
          <SidebarLink title="Inventory" faIcon="warehouse" route="/inventory/warehouse" onClick={this.hideSidebar} />
          <SidebarLink title="Report" faIcon="chart-line" route="/report" onClick={this.hideSidebar} /> */}
        </ul>
      </div>
    );
  }
}

export default SidebarContent;
